import GlpFileViewer from './GlpFileViewer.vue'

export { GlpFileViewer }
